import { useTitrePage } from '@/lib/titre-page';
import { Button } from '@pms-digital/design-system';

interface ErreurServiceProps {
  onReessayer: () => void;
}

/** The service cannot be reached, or answered something unexpected. */
export function ErreurService({ onReessayer }: ErreurServiceProps) {
  useTitrePage('Service indisponible');
  return (
    <div role="alert" className="flex flex-col items-start gap-6">
      <div className="flex flex-col gap-2">
        <h1 className="font-light text-h2 leading-[1.2]">Le service est indisponible.</h1>
        <p className="text-body text-gray-700">La traduction n'a pas pu être lue.</p>
      </div>
      <Button type="button" variant="primary" onClick={onReessayer}>
        réessayer
      </Button>
    </div>
  );
}
